import type { EventSourceFunc } from '@fullcalendar/core';

/** Shared ref read by a stable event-source function (see FullCalendar #7488). */
export const mainCalendarEventsRef: { current: object[] } = { current: [] };

const fetchMainCalendarEvents: EventSourceFunc = (_fetchInfo, successCallback) => {
  successCallback(mainCalendarEventsRef.current);
};

export const MAIN_CALENDAR_EVENT_SOURCES = [{ events: fetchMainCalendarEvents }];
